import { render, staticRenderFns } from "./RipaStopsGrid.vue?vue&type=template&id=23769a9b"
import script from "./RipaStopsGrid.vue?vue&type=script&lang=js"
export * from "./RipaStopsGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaStopsGrid.vue?vue&type=style&index=0&id=23769a9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports